import React, { useState } from "react";
import { FaEllipsisV, FaCommentDots, FaEdit } from "react-icons/fa";
import "./corporateLeads.css";

const CorporateLeadsTable = ({
  leads = [],
  handleActionClick,
  handleCommentSave,
  activeTab,
}) => {
  const MIN_ROWS = 10;
  const paddedLeads = [
    ...leads,
    ...Array(Math.max(0, MIN_ROWS - leads.length)).fill(null),
  ];

  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [openCommentIndex, setOpenCommentIndex] = useState(null);
  const [commentText, setCommentText] = useState({});
  const [originalComment, setOriginalComment] = useState({});

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const toggleCommentEdit = (index, existingComment = "") => {
    setOpenCommentIndex(index);
    setCommentText((prev) => ({
      ...prev,
      [index]: existingComment,
    }));
    setOriginalComment((prev) => ({
      ...prev,
      [index]: existingComment,
    }));
  };

  const handleSave = (index, lead) => {
    const newComment = commentText[index];
    if (newComment !== originalComment[index]) {
      handleCommentSave(lead, newComment);
    }
    setOpenCommentIndex(null);
  };

  const handleDiscard = (index) => {
    setCommentText((prev) => ({
      ...prev,
      [index]: originalComment[index],
    }));
    setOpenCommentIndex(null);
  };

  return (
    <div
      className="table-responsive"
      style={{ minHeight: "70vh" }}
    >
      <table className="table table-bordered table-sm align-middle text-center mb-0 corporate-leads-table">
        <thead className="table-light sticky-top">
          <tr>
            <th>Company Name</th>
            <th>Phone Number</th>
            <th>Selected Meal × Quantity</th>
            <th>Preference</th>
            <th>Cuisine</th>
            <th>Comments</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paddedLeads.map((lead, index) =>
            lead ? (
              <React.Fragment key={index}>
                <tr>
                  <td>{lead.companyName}</td>
                  <td>{lead.phoneNumber}</td>
                  <td>
                    {lead.menuName} × {lead.quantity}
                  </td>
                  <td>{lead.preference}</td>
                  <td>{lead.cuisine}</td>
                  <td className="text-start">
                    {openCommentIndex === index ? (
                      <div className="p-1">
                        <textarea
                          className="form-control"
                          rows={2}
                          value={commentText[index]}
                          onChange={(e) =>
                            setCommentText((prev) => ({
                              ...prev,
                              [index]: e.target.value,
                            }))
                          }
                          placeholder="Add comment..."
                        />
                        <div className="mt-1 d-flex gap-2">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => handleSave(index, lead)}
                            disabled={
                              commentText[index] === originalComment[index]
                            }
                          >
                            Save
                          </button>
                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => handleDiscard(index)}
                          >
                            Discard
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-between align-items-baseline">
                        <div
                          style={{ whiteSpace: "pre-wrap", maxWidth: "280px" }}
                        >
                          {lead.comments ? (
                            <span>{lead.comments}</span>
                          ) : (
                            <span className="text-muted">No comment</span>
                          )}
                        </div>
                        <button
                          className="btn btn-sm p-1 ms-2"
                          title="Edit Comment"
                          onClick={() =>
                            toggleCommentEdit(index, lead.comment || "")
                          }
                        >
                          <FaEdit />
                        </button>
                      </div>
                    )}
                  </td>
                  <td className="position-relative">
                    {activeTab !== "Dropped" && (
                      <>
                        <button
                          className="dots-button"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FaEllipsisV color="#2D2D56" />
                        </button>

                        {openDropdownIndex === index && (
                          <div
                            className="dropdown-menu show position-absolute mt-1 corporate-leads-dropdown"
                            style={{
                              right: "auto",
                              left: "-100px",
                              zIndex: 999,
                            }}
                          >
                            {activeTab === "Leads" && (
                              <>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    handleActionClick("Contacted", lead)
                                  }
                                >
                                  Move to Contacted
                                </button>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    handleActionClick("Dropped", lead)
                                  }
                                >
                                  Move to Dropped
                                </button>
                              </>
                            )}
                            {activeTab === "Contacted" && (
                              <button
                                className="dropdown-item"
                                onClick={() =>
                                  handleActionClick("Dropped", lead)
                                }
                              >
                                Move to Dropped
                              </button>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              </React.Fragment>
            ) : (
              <tr key={`empty-${index}`}>
                {Array(7)
                  .fill(null)
                  .map((_, i) => (
                    <td key={i} style={{ height: "40px" }}>
                      &nbsp;
                    </td>
                  ))}
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CorporateLeadsTable;
